import styled from "styled-components";
import Button from "@material-ui/core/Button";
import getMeta from "../services/getMetaFromLink";
import { Modal, Container } from "@material-ui/core";

import { useState } from "react";

interface SingleOffchainMetadata {
  name: string;
  description: string;
  image: string;
}
interface SingleMetadata {
  name: string;
  link: string;
}
export const CTAButton = styled(Button)`
  width: 100%;
  height: 100%;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #550041 0%, #e1694c 100%);
  color: white !important;
  font-size: 10px;
  font-weight: bold;
`;

let data: SingleOffchainMetadata;
export const SingleNFT = ({ item }: { item: SingleMetadata }) => {
  const [metadata, setMetadata] = useState<SingleOffchainMetadata>();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    const fetchData = async () => {
      data = await getMeta(item["link"]);
      console.log(item["link"]);
      setMetadata(data);
      setLoading(false);
    };
    fetchData();
  };
  const handleClose = () => setOpen(false);

  const renderMetaData = () => {
    return (
      <div className="gif-grid">
        {!loading && metadata ? (
          <Container maxWidth="xs" style={{ position: "relative" }}>
            <div>
              {<a href={metadata["name"]}>{metadata["description"]}</a>}
              <img
                src={metadata["image"]}
                alt={metadata["name"]}
                width="100%"
              />
            </div>
          </Container>
        ) : (
          "loading"
        )}
      </div>
    );
  };
  return (
    <>
      <CTAButton onClick={handleOpen}>Open details {item["name"]}</CTAButton>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          width: "50%",
          marginTop: "30px",
          marginLeft: "300px",
          height: "100%",
        }}
      >
        <div className="smallTerminal">
          <section className="terminal__bar">
            <div className="bar__buttons">
              <button
                className="bar__button bar__button--exit"
                onClick={handleClose}
              >
                &#10005;
              </button>
              <button className="bar__button">&#9472;</button>
              <button className="bar__button">&#9723;</button>
            </div>
            <p className="bar__user">CMmeta@ubuntu: ~</p>
          </section>

          <section className="terminal__body">
            <div className="terminal__prompt">
              <span className="terminal__prompt--user">CMmeta@ubuntu:</span>
              <span className="terminal__prompt--location">~</span>

              <span className="terminal__prompt--bling">$</span>
              {data && renderMetaData()}
              {/*    <span className="terminal__prompt--cursor"></span> */}
            </div>
          </section>
        </div>
      </Modal>
    </>
  );
};
